import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postDuplicateContractEndpoint } from '../../../common/endpoints';

export const duplicateContractData = createApi(postDuplicateContractEndpoint, 'POST');

const DuplicateContracts = createSlice({
  name: 'DuplicateContracts',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(duplicateContractData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(duplicateContractData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(duplicateContractData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default DuplicateContracts.reducer;